import React from 'react';

import { UiTypography } from '@/components/ui/Typography';

import {
  DominateOptionItemSpriteStyles,
  OptionItemSpriteImageContainerStyles,
  OptionItemSpriteListStyles,
  TitleContainerStyles,
} from './DominateOptionItemSprite.styles';

export const DominateOptionItemSpriteList: React.FC<{
  children?: NonNullable<React.ReactNode>;
  className?: string;
}> = ({ children, className }) => {
  return (
    <OptionItemSpriteListStyles className={className}>
      {children}
    </OptionItemSpriteListStyles>
  );
};

export const DominateOptionItemSprite: React.FC<{
  spriteSrc: string;
  alt: string;
  title: string;
  subtitle?: string;
  isSelected: boolean;
  onClick: () => void;
  TEST_ID?: string;
}> = ({ alt, spriteSrc, title, subtitle, isSelected, onClick, TEST_ID }) => {
  return (
    <DominateOptionItemSpriteStyles
      isSelected={isSelected}
      onClick={onClick}
      data-testid={TEST_ID}
    >
      <TitleContainerStyles>
        <UiTypography
          className="option-item-sprite-title"
          variant="label-large"
        >
          {title}
        </UiTypography>
        {subtitle && (
          <UiTypography
            className="option-item-sprite-subtitle"
            variant="body-small"
          >
            {subtitle}
          </UiTypography>
        )}
      </TitleContainerStyles>
      <OptionItemSpriteImageContainerStyles isSelected={isSelected}>
        <img src={spriteSrc} alt={alt} />
      </OptionItemSpriteImageContainerStyles>
    </DominateOptionItemSpriteStyles>
  );
};
